import { integer, pgTable, text, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import { z } from "zod";

import { usStatesEnum, usStatesEnumSchema } from "./commonSchema";
import { customTimestamp } from "./utils/types";

export const workRequirementUsStateRulesTable = pgTable(
  "work_requirement_us_state_rules",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    usState: usStatesEnum("us_state").notNull().unique(),
    requiredMonthlyHours: integer("required_monthly_hours").notNull(),
    // Whole dollars. Pay is converted to hours at threshold / required hours
    // (the federal minimum wage: $580 / 80h = $7.25).
    monthlyIncomeThreshold: integer("monthly_income_threshold").notNull(),
    // Months before the work requirement date that need proof of work.
    lookbackMonths: integer("lookback_months").notNull(),
    // Onboarding shows the action campaign at or below this many days before
    // the work requirement date, and the assistance campaign above it.
    actionCampaignThresholdDays: integer(
      "action_campaign_threshold_days",
    ).notNull(),
    minAge: integer("min_age").notNull(),
    maxAge: integer("max_age").notNull(),
    volunteerOpportunitiesUrl: text("volunteer_opportunities_url").notNull(),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
    updatedAt: customTimestamp("updated_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString())
      .$onUpdateFn(() => new Date().toISOString()),
  },
);

export const insertWorkRequirementUsStateRuleSchema = createInsertSchema(
  workRequirementUsStateRulesTable,
  {
    usState: usStatesEnumSchema,
    volunteerOpportunitiesUrl: z.url(),
  },
).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});
export type InsertWorkRequirementUsStateRuleType = z.infer<
  typeof insertWorkRequirementUsStateRuleSchema
>;

export const workRequirementUsStateRuleSchema = createSelectSchema(
  workRequirementUsStateRulesTable,
  { usState: usStatesEnumSchema },
);
export type WorkRequirementUsStateRuleType = z.infer<
  typeof workRequirementUsStateRuleSchema
>;
